import FeedbackPage from '@/components/FeedbackPage'
import { getAgeFeedback } from '@/utils/feedbackContent'

export default function AgeFeedbackPage() {
  return <FeedbackPage {...getAgeFeedback()} />
}
